import { useCallback, useContext } from 'react';
import { ThemeSetterContext } from './ThemeProvider';

const useSetTheme = () => {
  // Replace current theme with provided object
  const setTheme = useContext(ThemeSetterContext); // Fail fast if dev uses useSetTheme outside of ThemeProvider

  if (setTheme instanceof Error) {
    throw setTheme;
  } // Merge provided object into current theme


  const editTheme = useCallback(newTheme => setTheme(function () {
    let oldTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return { ...oldTheme,
      ...newTheme
    };
  }), [setTheme]);
  return {
    setTheme,
    editTheme
  };
};

export default useSetTheme;